import Vue from "vue";
import Vuex from "vuex";

import global from "./modules/global";
import lightBox from "./modules/lightBox";
import navigation from "./modules/navigation";

// Vuex
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    global,
    lightBox,
    navigation
  },
  strict: process.env.NODE_ENV !== "production"
});

export default store;
